<template>
  <!-- eslint-disable -->
  <div>
    <b-overlay variant="white" :show="showLoading" spinner-variant="primary" blur="0" opacity=".75" rounded="sm">
      <stock-filters />
      <b-card no-body class="mb-0">
        <b-table
          class="position-relative"
          :hover="true"
          :items="records"
          responsive
          :fields="fields"
          show-empty
          empty-text="No existen"
          @sort-changed="sortChanged"
        >
        <template v-slot:cell(qtyAvaible)="{ item, field: { key }, index }">
            <span >{{ item.qty }}</span>
          </template>
          <template v-slot:cell(qty)="{ item, field: { key }, index }">
            <b-input-group v-if="(isEdit == true && indexSelected == index)">
              <b-form-input v-model="item[key]" style="width: 150px" type="number" @keypress="onlyNumbers($event)" />
            </b-input-group>
            <span v-else>{{ item[key] }}</span>
          </template>
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <b-button
              v-if="(isEdit == false)"
              size="sm"
              @click.prevent="setBeforeData(data.item,data.index)"
              class=""
              v-b-tooltip.hover.top="'Editar'"
              variant="flat-secondary"
            >
              <feather-icon icon="Edit2Icon" />
            </b-button>
            <b-button
              v-if="(isEdit == true && indexSelected == data.index)"
              size="sm"
              @click.prevent="updateStock(data.item)"
              class=""
              v-b-tooltip.hover.top="'Guardar'"
              variant="flat-success"
            >
              <feather-icon icon="SaveIcon" />
            </b-button>
            <b-button
              v-if="(isEdit == true && indexSelected == data.index)"
              size="sm"
              @click.prevent="cancel"
              class=""
              v-b-tooltip.hover.top="'Cancelar'"
              variant="flat-danger"
            >
              <feather-icon icon="XIcon" />
            </b-button>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col sm="3">
              <b-form-group label-cols="4" label-cols-md="4" label-size="md" label="Entradas" label-for="input-md">
                <b-form-select
                  v-model="showEntrie"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="title"
                  :options="entries"
                  @change="changeSizePage"
                />
              </b-form-group>
            </b-col>
            <b-col sm="3" class="mt-75" style="font-size: 12px">
              <span> {{ totalElements }} Registros en total</span>
            </b-col>
            <!-- Pagination -->
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalElements"
                :per-page="showEntrie"
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
                @change="cambioPagina"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
//import stockFilters from './stockFilters.vue'
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import StockService from '@/services/StockService'
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple
  },
  data() {
    return {
      showLoading: false,
      records: [],
      auxItems: [],
      isEdit: false,
      fields: [
        //{ key: 'id', label: 'Nº', sortable: false },
        { key: 'autopart.uniqueCode', label: 'Codigo Único', sortable: true },
        { key: 'autopart.originalCode', label: 'Codigo Original', sortable: true },
        { key: 'autopart.alterCode', label: 'Codigo Alter.', sortable: true },
        { key: 'store.name', label: 'Tienda', sortable: true },
        { key: 'autopart.description', label: 'Descripción', sortable: true },
        { key: 'autopart.autopartBrand.name', label: 'Marca', sortable: true },
        { key: 'autopart.vehicleModel.model', label: 'Modelo', sortable: false },
        { key: 'qty_available', label: 'Cantidad Disponible', sortable: true },
        { key: 'qty', label: 'Cantidad', sortable: true },
        { key: 'actions', label: 'Acciones' }
        // { key: 'autopart.retailPrice', label: 'Precio x Menor', sortable: false },
        // { key: 'autopart.wholesalePrice', label: 'Precio x Mayor', sortable: false },
      ],
      lastQty: null,
      indexSelected: null,
      arrayFilters: [],
      currentPage: 1,
      entries: [10, 20, 50, 100],
      showEntrie: 10,
      totalElements: 0,
      id: 0,
      sort: 'id',
      order: 'desc'
    }
  },
  components: {
    stockFilters
  },
  mounted() {
    this.getData()
  },
  methods: {
    setBeforeData(item,index){
      this.lastQty = item.qty
      this.isEdit = true
      this.indexSelected = index
    },
    cancel(){
      this.isEdit = false
      this.getData()
    },
    async updateStock(item){
      this.isDisabled = true
      let form = {}
      form.qty = parseInt(item.qty)
      form.beforeQty = parseInt(this.lastQty)
      const resp = await StockService.saveStock(item.id, form,this.$store)
      console.log('resp',resp)
      if (resp) {
        this.$swal({
          title: 'Actualizado',
          text: 'El stock ha sido actualizado',
          icon: 'success',
          customClass: {
            confirmButton: 'btn btn-primary'
          },
          buttonsStyling: false
        })
        this.isEdit = false
        this.isDisabled = false
        this.getData()
      }
    },
    onlyNumbers(e) {
      if ((e.keyCode >= 48 && e.keyCode <= 57) || e.keyCode == 46) {
        return true
      } else {
        e.preventDefault()
      }
    },
    cambioPagina(e) {
      this.currentPage = e
      this.getData()
    },
    changeSizePage() {
      this.getData()
    },
    sortChanged(data) {
      this.sort = data.sortBy
      if (data.sortDesc) {
        this.order = 'desc'
      } else this.order = 'asc'
    },
    async getData() {
      this.records = []
      this.totalElements = 0
      const resp = await StockService.getListMovements(this.$store)
      if (resp.stocks.length != 0) {
        this.records = resp.stocks
        this.totalElements = resp.itemCount
      }
    }
  }
}
</script>

<style></style>
